import styled from 'styled-components';
import colors from '../../utils/colors';
import mediaQueries from '../../utils/mediaQueries';
import typography from '../../utils/typography';
import { StyledText } from '../Text/Text.styles';
import TextLink from '../TextLink';
const { lightGrey, meld, white } = colors;
const { display6, smallCopy, mainCopy } = typography;
export const StyledCopyright = styled(StyledText)
    .attrs({ color: meld })
    .withConfig({
    shouldForwardProp: (prop) => !['renderonsidebar'].includes(prop),
})(({ renderonsidebar }) => [
    renderonsidebar ? smallCopy : mainCopy,
]);
export const StyledFooter = styled.footer.withConfig({
    shouldForwardProp: (prop) => !['renderonsidebar'].includes(prop),
})(({ renderonsidebar }) => [
    display6,
    {
        boxSizing: 'border-box',
        display: 'flex',
        width: '100%',
        borderTop: `1px solid ${lightGrey}`,
        backgroundColor: white,
    },
    renderonsidebar
        ? {
            flexDirection: 'column-reverse',
            padding: '1rem 1rem 1rem 2rem',
            rowGap: '0.5rem',
        }
        : {
            flexShrink: 0,
            display: 'flex',
            flexWrap: 'wrap-reverse',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '3.75rem',
            '--footer-spacing-x': '1.5rem',
            '--footer-spacing-y': '0.625rem',
            padding: 'var(--footer-spacing-y) var(--footer-spacing-x)',
            columnGap: 'var(--footer-spacing-x)',
            [mediaQueries.from('sm')]: {
                '--footer-spacing-x': '2.25rem',
                flexWrap: 'nowrap',
            },
            [mediaQueries.from('md')]: {
                '--footer-spacing-y': '0.75rem',
            },
            [mediaQueries.from('lg')]: {
                '--footer-spacing-x': '4rem',
            },
        },
]);
export const StyledUnorderedList = styled.ul.withConfig({
    shouldForwardProp: (prop) => !['renderonsidebar'].includes(prop),
})(({ renderonsidebar }) => [
    {
        boxSizing: 'border-box',
        padding: '0',
        margin: '0',
        listStyleType: 'none',
        flexGrow: '1',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-around',
    },
    renderonsidebar
        ? {
            display: 'grid',
            gridRowGap: '0.5rem',
            gridRowStart: '1',
            gridTemplateColumns: '50% 50%',
        }
        : {
            '--footer-links-spacing-x': '1.5rem',
            columnGap: 'var(--footer-links-spacing-x)',
            '> *': { flex: '1 1 calc(100% / 3 - var(--footer-links-spacing-x))' },
            [mediaQueries.from('sm')]: {
                '--footer-links-spacing-x': '3.25rem',
            },
            [mediaQueries.from('md')]: {
                justifyContent: 'center',
                '> *': { flex: '0' },
            },
        },
]);
export const StyledListItem = styled.li.withConfig({
    shouldForwardProp: (prop) => !['renderonsidebar'].includes(prop),
})(({ renderonsidebar }) => [
    {
        display: 'flex',
        alignItems: 'center',
        justifyContent: renderonsidebar ? 'flex-start' : 'center',
    },
]);
export const StyledTextLink = styled(TextLink)({
    whiteSpace: 'nowrap',
    [mediaQueries.to('sm')]: {
        fontSize: '0.75rem',
    },
});
